module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Umbrella-c5d0c70a95cbbb3b94fb63f24f3f6fb0.svg";